import React, { useEffect, useRef, useState } from "react";

export const TRACKER_FILTERS = {
  DISABLED_NEWEST: "disabled-newest",
  DISABLED_OLDEST: "disabled-oldest",
};

const FILTER_OPTIONS = [
  {
    id: TRACKER_FILTERS.DISABLED_NEWEST,
    label: "Disabled tracker — newest first",
    description: "Replacement off, from new to old",
  },
  {
    id: TRACKER_FILTERS.DISABLED_OLDEST,
    label: "Disabled tracker — oldest first",
    description: "Replacement off, from old to new",
  },
];

export const getTrackerFilterLabel = (filterId) =>
  FILTER_OPTIONS.find((option) => option.id === filterId)?.label || "";

const AdminFilterButton = ({ value, onChange }) => {
  const [open, setOpen] = useState(false);
  const rootRef = useRef(null);

  useEffect(() => {
    if (!open) return undefined;

    const handlePointerDown = (event) => {
      if (rootRef.current && !rootRef.current.contains(event.target)) {
        setOpen(false);
      }
    };

    const handleEscape = (event) => {
      if (event.key === "Escape") {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", handlePointerDown);
    document.addEventListener("keydown", handleEscape);

    return () => {
      document.removeEventListener("mousedown", handlePointerDown);
      document.removeEventListener("keydown", handleEscape);
    };
  }, [open]);

  const isActive = Boolean(value);

  return (
    <div ref={rootRef} className="relative">
      <button
        type="button"
        onClick={() => setOpen((prev) => !prev)}
        className={`p-3 rounded-full shadow-lg z-40 transition-colors flex items-center justify-center ${
          isActive
            ? "bg-amber-500 hover:bg-amber-400 ring-2 ring-white/70"
            : "bg-amber-600 hover:bg-amber-700"
        } text-white`}
        title="Filter"
        aria-label="Filter"
        aria-expanded={open}
        aria-haspopup="menu"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="28"
          height="28"
          viewBox="0 0 16 16"
          aria-hidden="true"
        >
          <title>filter</title>
          <path
            fill="currentColor"
            d="M6 10.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5m-2-3a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5m-2-3a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5"
          />
        </svg>
      </button>

      {open && (
        <div
          role="menu"
          className="absolute bottom-0 left-full z-50 ml-3 w-72 overflow-hidden rounded-xl border border-white/10 bg-[#1e2433] shadow-2xl"
        >
          {FILTER_OPTIONS.map((option) => {
            const selected = value === option.id;

            return (
              <button
                key={option.id}
                type="button"
                role="menuitem"
                onClick={() => {
                  onChange(selected ? null : option.id);
                  setOpen(false);
                }}
                className={`w-full px-4 py-3 text-left transition-colors ${
                  selected
                    ? "bg-amber-500/20 text-white"
                    : "text-gray-200 hover:bg-white/10"
                }`}
              >
                <div className="text-sm font-medium">{option.label}</div>
                <div className="mt-0.5 text-xs text-gray-400">
                  {option.description}
                </div>
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default AdminFilterButton;
